import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

// Get user's restaurant ID from their profile
export const getUserRestaurant = async (userId) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      return userDoc.data().restaurantId;
    }
    return null;
  } catch (error) {
    console.error('Error fetching user restaurant:', error);
    return null;
  }
};

// Create user profile and link to restaurant
export const createUserProfile = async (userId, email, restaurantId) => {
  try {
    await setDoc(doc(db, 'users', userId), {
      email,
      restaurantId,
      role: 'admin',
      createdAt: new Date()
    });
    return true;
  } catch (error) {
    console.error('Error creating user profile:', error);
    return false;
  }
};

// Initialize restaurant for new admin
export const initializeRestaurant = async (restaurantId, data) => {
  try {
    await setDoc(doc(db, 'restaurants', restaurantId), {
      ...data,
      createdAt: new Date(),
      currency: 'EUR',
      timezone: 'Europe/Paris'
    });
    return true;
  } catch (error) {
    console.error('Error initializing restaurant:', error);
    return false;
  }
};
